module.exports = __webpack_public_path__ + "static/img/rydb1.6216b23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/rydb1.png
// module id = w/xW
// module chunks = 43